import { createFileRoute } from "@tanstack/react-router";

import { DashboardsCatalog } from "../tools/dashboards/DashboardsCatalog";

function DashboardsIndexRoute() {
  return <DashboardsCatalog />;
}

export const Route = createFileRoute("/_app/dashboards/")({
  component: DashboardsIndexRoute,
});
